function toggle_btn_updatecart() {
  $.ajax({
    url: "/cart?view=cst",
    type: "GET",
    response: "html",
    async: false,
    success: function (data) {
      // $(
      //   ".sidebar_area .side_bar_drawer__scrollable,.sidebar_area .total_price,.sidebar_count"
      // ).empty();
      var items = $(data).find("#CartPageForm [data-products]").html();
      if (!items) {
        // $('.sidebar_area').addClass('empty');
        //items = '<div class="empty-cart-mssg"><div class="title">Empty Cart, Full of Fresh, Goal-Crushing Potential.</div><div><a href="/collections/all-meals" class="btn btn-outline btn--no-animate js-no-transition">Explore the menu</a></div></div>';
      } else {
        $(".sidebar_area").removeClass("empty");
      }

      $(".sidebar_area .side_bar_drawer__scrollable").html(items);
      var subtotal = $(data).find(".cart__footer [data-subtotal]").html();
      $(".sidebar_area .total_price").html(subtotal);
      var price_per = $(data).find(".cart__footer [data-price-per]").html();
      if (!price_per) price_per = "0";
      $(".sidebar_area .price-per").html(price_per);
      var count = $(data).find(".cart__footer [data-totalitems]").html();
      if (!count) count = 0;
      var ict = $("#ictct").val();
      var mcount = count + "/" + ict;
      $("#cart_count").html(count);
      count = parseInt(count);
      ict = parseInt(ict);
      mcount = "Choose " + ict + "+ Meals";
      $(".sidebar_area .sidebar_count").html(mcount);
      if (count >= ict) {
        $(".sidebar_count").css("display", "none");
        $(".sidebar_checkout,.meals_check").css("display", "block");
      } else {
        $(".sidebar_checkout,.meals_check").css("display", "none");
        $(".sidebar_count").css("display", "block");
      }

      $(".cart-link__bubble").text(count);

      if (count > 0) {
        $(".cart-link__bubble").addClass("cart-link__bubble--visible");
      } else {
        $(".cart-link__bubble").removeClass("cart-link__bubble--visible");
      }

      if (count < 7) {
        $(".sidebar_checkoutmeal").addClass("hide");
        $(".sidebar_counter").removeClass("hide");
        $(".fast-checkout,.custom_area").css("display", "none");
        $(".orderline span")
          .attr("class", "")
          .addClass("count-" + count);
        $(".count-left").text(7 - count);
        $(".sidebar_min .mssg").text("Choose 7+ meals");
        $(".sidebar_area").removeClass("minimum");
        // $(".one-item-purchase-meals.custom_area").css("display", "block");
      } else if (count >= 7) {
        if (!$(".orderline span").hasClass("full")) {
          $(".sidebar_min .mssg").text("Subscribe for free shipping");
          $(".orderline span").attr("class", "").addClass("full");
        }
        $(".sidebar_area").addClass("minimum");
        $(".sidebar_checkoutmeal").removeClass("hide");
        $(".sidebar_counter").addClass("hide");
        $(".fast-checkout,.custom_area").css("display", "block");
        $(".fast-checkout,.custom_area").css("display", "block");
      }
      function isEmpty(el) {
        return !$.trim(el.html());
      }
      if (isEmpty($(".sidebar_area .total_price"))) {
        $(".sidebar_area .total_price").html("$0.00");
      }
      $.getJSON("/cart.js", function (cart) {
        var vl = cart.item_count;
        if (vl == 0) {
          $(".cart-link__bubble").removeClass("cart-link__bubble--visible");
        } else {
          $(".cart-link__bubble").addClass("cart-link__bubble--visible");
        }

        const SkioBABDiscount = document.querySelectorAll("skio-bab-discount");
        if (SkioBABDiscount.length) {
          SkioBABDiscount.forEach((el) => (el.productCount = cart.item_count));
        }
      });
    },
  });
}

function skioGetDynamicBundleItems(bundle) {
  return bundle.selections.map((item) => ({
    id: item.externalVariantId,
    quantity: item.quantity,
    selling_plan: item.sellingPlan,
    properties: {
      _dynamicBoxId: "505328c4-d2f4-4a62-95fe-dee3b342d073",
      _dynamicBoxIndex: 0,
    },
  }));
}

function allunsub() {
  console.log("allunsub");

  var v = [];
  var x = [];
  var y = [];
  var z = [];

  $.ajax({
    async: false,
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    contentType: "application/json",
    success: function (data) {
      var it = data.items;

      for (var i = 0; i < it.length; i++) {
        v[i] = data.items[i].variant_id;
        x[i] = data.items[i].quantity;
        y[i] = data.items[i].properties._selling_1;
        z[i] = data.items[i].properties._selling_2;
      }
    },
  });

  $.ajax({
    async: false,
    type: "POST",
    url: "/cart/clear.js",
    success: function () {
      console.log("clear");
    },
    dataType: "json",
  });

  var cdata = [];

  for (var i = 0; i < v.length; i++) {
    cdata.push({
      quantity: x[i],
      id: v[i],
      properties: {
        _selling_1: y[i],
        _selling_2: z[i],
        _dynamicBoxId: "505328c4-d2f4-4a62-95fe-dee3b342d073",
        _dynamicBoxIndex: 0,
      },
    });
  }

  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: { items: cdata },
    dataType: "json",
    success: function () {
      window.location.replace("/checkout");
    },
  });
}

function allone() {
  console.log("allone");

  var v = [];
  var x = [];
  var y = [];
  var z = [];
  var p = [];

  $.ajax({
    async: false,
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    contentType: "application/json",
    success: function (data) {
      var it = data.items;

      for (var i = 0; i < it.length; i++) {
        v[i] = data.items[i].variant_id;
        x[i] = data.items[i].quantity;
        y[i] = data.items[i].properties._selling_1;
        z[i] = data.items[i].properties._selling_2;
        p[i] = data.items[i].product_id;
      }
    },
  });

  $.ajax({
    async: false,
    type: "POST",
    url: "/cart/clear.js",
    success: function () {
      console.log("clear");
    },
    dataType: "json",
  });

  // need to add selling plan properties to convert when a User comes back from checkout
  const bundleProductData = {
    productId: "8331609505970",
    variantId: "44808694956210",
    sellingPlan: 2438758578,
    handle: "custom-bundle-volume-discount-shipping",
  };

  const bundle = {
    externalVariantId: bundleProductData.variantId,
    externalProductId: bundleProductData.productId,
    selections: [],
  };

  for (var i = 0; i < v.length; i++) {
    bundle.selections.push({
      collectionId: "158043177011",
      externalProductId: p[i],
      externalVariantId: v[i],
      quantity: x[i],
      sellingPlan: y[i],
    });
  }
  const cartItems = skioGetDynamicBundleItems(bundle);

  for (var h = 0; h < cartItems.length; h++) {
    cartItems[h].properties["_selling_1"] = y[h];
    cartItems[h].properties["_selling_2"] = z[h];
  }
  const cartData = { items: cartItems };

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(cartData),
  }).then((response) => {
    window.location.href = "/checkout";
  });
}

function alltwo() {
  console.log("alltwo");

  var v = [];
  var x = [];
  var y = [];
  var z = [];
  var p = [];

  $.ajax({
    async: false,
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    contentType: "application/json",
    success: function (data) {
      var it = data.items;

      for (var i = 0; i < it.length; i++) {
        v[i] = data.items[i].variant_id;
        x[i] = data.items[i].quantity;
        y[i] = data.items[i].properties._selling_1;
        z[i] = data.items[i].properties._selling_2;
        p[i] = data.items[i].product_id;
      }
    },
  });

  $.ajax({
    async: false,
    type: "POST",
    url: "/cart/clear.js",
    success: function () {
      console.log("clear");
    },
    dataType: "json",
  });

  const bundleProductData = {
    productId: "8331609505970",
    variantId: "44808694956210",
    sellingPlan: 2438758578,
    handle: "custom-bundle-volume-discount-shipping",
  };

  const bundle = {
    externalVariantId: bundleProductData.variantId,
    externalProductId: bundleProductData.productId,
    selections: [],
  };

  for (var i = 0; i < v.length; i++) {
    bundle.selections.push({
      collectionId: "158043177011",
      externalProductId: p[i],
      externalVariantId: v[i],
      quantity: x[i],
      sellingPlan: z[i],
    });
  }
  const cartItems = skioGetDynamicBundleItems(bundle);

  for (var h = 0; h < cartItems.length; h++) {
    cartItems[h].properties["_selling_1"] = y[h];
    cartItems[h].properties["_selling_2"] = z[h];
  }
  const cartData = { items: cartItems };

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(cartData),
  }).then((response) => {
    window.location.href = "/checkout";
  });
}

function checkallitems(mydata) {
  var th = 0;

  var thm = 0;

  var tym = 0;

  var myd = mydata.items;

  for (var i = 0; i < myd.length; i++) {
    var last = myd.length;
    last = last - 1;
    if (myd[last].selling_plan_allocation == null) {
      if (thm != 1 && tym != 1) {
        th = 1;

        break;
      }
    } else {
      if (
        myd[last].selling_plan_allocation.selling_plan.name.toLowerCase() ==
        "every week"
      ) {
        if (tym != 1 && th != 1) {
          thm = 1;

          break;
        }
      }

      if (
        myd[last].selling_plan_allocation.selling_plan.name.toLowerCase() ==
        "every 2 weeks"
      ) {
        if (th != 1 && thm != 1) {
          tym = 1;

          break;
        }
      }
    }
  }

  if (th == 1) {
    // all items should be non sub

    allunsub();
  }

  if (thm == 1) {
    // all items should be sub with 1 week freq

    allone();
  }

  if (tym == 1) {
    // all items should be sub with 2 weeks freq

    alltwo();
  }
}

$(document).ready(function () {
  var qa = 0;
  $.ajax({
    async: false,
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    contentType: "application/json",
    success: function (data) {
      // checkallitems(data);
      var pros = data.items.length;
      if (pros > 0) {
        console.log(pros);
        for (var i = 0; i < pros; i++) {
          if (data.items[i].selling_plan_allocation == null) {
            qa = 0;
          } else {
            if (
              data.items[
                i
              ].selling_plan_allocation.selling_plan.name.toLowerCase() ==
              "every week"
            ) {
              qa = 1;
            }

            if (
              data.items[
                i
              ].selling_plan_allocation.selling_plan.name.toLowerCase() ==
              "every 2 weeks"
            ) {
              qa = 2;
            }
          }
        }
      } else {
        if ($(".custom_area").hasClass("one-item-purchase-meals")) {
          qa = 0;
        } else {
          qa = 1;
        }
      }
    },
  });

  if (qa == 0) {
    console.log("non sub");
    $("input[name^=wklychb]").prop("checked", false);
    $(".subscritpion_area").css("display", "none");
    $("#shiprice").html("$19.95");
  }

  if (qa == 1) {
    console.log("sub 1 week");
    $("input[name^=wklychb]").prop("checked", true);
    $("#firstone").removeClass("selected");
    $("#secondone").addClass("selected");
    $(".subscritpion_area").css("display", "block");
    // $("#shiprice").html("FREE!");
  }

  if (qa == 2) {
    console.log("sub 2 week");

    $("input[name^=wklychb]").prop("checked", true);

    $("#firstone").addClass("selected");

    $("#secondone").removeClass("selected");

    $(".subscritpion_area").css("display", "block");
    // $("#shiprice").html("FREE!");
  }
});

$(".quantities-selector").click(function () {
  var a = [];
  var b = [];
  var c = [];
  var d = [];
  var p = [];

  if ($("#firstone").hasClass("selected")) {
    var freq = 1;

    localStorage.setItem("freq", JSON.stringify(freq));

    $.ajax({
      async: false,
      type: "GET",
      url: "/cart.js",
      dataType: "json",
      contentType: "application/json",
      success: function (data) {
        console.log(data.items);

        var pros = data.items.length;

        for (var i = 0; i < pros; i++) {
          a[i] = data.items[i].variant_id;
          b[i] = data.items[i].quantity;
          c[i] = data.items[i].properties._selling_1;
          d[i] = data.items[i].properties._selling_2;
          p[i] = data.items[i].product_id;
        }
      },
    });

    //remove all items from cart

    $.ajax({
      async: false,
      type: "POST",
      url: "/cart/clear.js",
      success: function () {
        console.log("clear");
      },
      dataType: "json",
    });

    var data = [];

    const bundleProductData = {
      productId: "8331609505970",
      variantId: "44808694956210",
      sellingPlan: 2438758578,
      handle: "custom-bundle-volume-discount-shipping",
    };

    const bundle = {
      externalVariantId: bundleProductData.variantId,
      externalProductId: bundleProductData.productId,
      selections: [],
    };

    for (var i = 0; i < a.length; i++) {
      bundle.selections.push({
        collectionId: "158043177011",
        externalProductId: p[i],
        externalVariantId: a[i],
        quantity: b[i],
        sellingPlan: c[i],
      });
    }

    const cartItems = skioGetDynamicBundleItems(bundle);

    for (var h = 0; h < cartItems.length; h++) {
      cartItems[h].properties["_selling_1"] = c[h];
      cartItems[h].properties["_selling_2"] = d[h];
    }
    const cartData = { items: cartItems };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(cartData),
    });
  } else {
    var freq = 2;

    localStorage.setItem("freq", JSON.stringify(freq));

    $.ajax({
      async: false,
      type: "GET",
      url: "/cart.js",
      dataType: "json",
      contentType: "application/json",
      success: function (data) {
        console.log(data.items);

        var pros = data.items.length;

        for (var i = 0; i < pros; i++) {
          a[i] = data.items[i].variant_id;
          b[i] = data.items[i].quantity;
          c[i] = data.items[i].properties._selling_1;
          d[i] = data.items[i].properties._selling_2;
          p[i] = data.items[i].product_id;
        }
      },
    });

    //remove all items from cart

    $.ajax({
      async: false,
      type: "POST",
      url: "/cart/clear.js",
      success: function () {
        console.log("clear");
      },
      dataType: "json",
    });

    var data = [];

    const bundleProductData = {
      productId: "8331609505970",
      variantId: "44808694956210",
      sellingPlan: 2438758578,
      handle: "custom-bundle-volume-discount-shipping",
    };

    const bundle = {
      externalVariantId: bundleProductData.variantId,
      externalProductId: bundleProductData.productId,
      selections: [],
    };

    for (var i = 0; i < a.length; i++) {
      bundle.selections.push({
        collectionId: "158043177011",
        externalProductId: p[i],
        externalVariantId: a[i],
        quantity: b[i],
        sellingPlan: d[i],
      });
    }

    const cartItems = skioGetDynamicBundleItems(bundle);

    for (var h = 0; h < cartItems.length; h++) {
      cartItems[h].properties["_selling_1"] = c[h];
      cartItems[h].properties["_selling_2"] = d[h];
    }
    const cartData = { items: cartItems };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(cartData),
    });
  }
});

// toggle button
$("input[name^=wklychb]").click(function () {
  var v = [];
  var x = [];
  var y = [];
  var z = [];
  var p = [];
  const bundleProductData = {
    productId: "8331609505970",
    variantId: "44808694956210",
    sellingPlan: 2438758578,
    handle: "custom-bundle-volume-discount-shipping",
  };

  const bundle = {
    externalVariantId: bundleProductData.variantId,
    externalProductId: bundleProductData.productId,
    selections: [],
  };
  $.ajax({
    async: false,
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    contentType: "application/json",
    success: function (data) {
      var it = data.items;

      for (var i = 0; i < it.length; i++) {
        v[i] = data.items[i].variant_id;
        x[i] = data.items[i].quantity;
        y[i] = data.items[i].properties._selling_1;
        z[i] = data.items[i].properties._selling_2;
        p[i] = data.items[i].product_id;
      }
    },
  });

  clearcart();

  if ($("input[name^=wklychb]").prop("checked")) {
    var data = [];
    for (var i = 0; i < v.length; i++) {
      bundle.selections.push({
        collectionId: "158043177011",
        externalProductId: p[i],
        externalVariantId: v[i],
        quantity: x[i],
        sellingPlan: y[i],
      });
    }

    const cartItems = skioGetDynamicBundleItems(bundle);

    for (var h = 0; h < cartItems.length; h++) {
      cartItems[h].properties["_selling_1"] = y[h];
      cartItems[h].properties["_selling_2"] = z[h];
    }
    const cartData = { items: cartItems };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(cartData),
    }).then((response) => {
      updatecart();
    });

    $(".subscritpion_area").css("display", "block");
    // $("#shiprice").html("FREE!");
    $("#secondone").addClass("selected");
  } else {
    $("#shiprice").html("$19.95");
    $(".subscritpion_area").css("display", "none");

    var data = [];

    for (var i = 0; i < v.length; i++) {
      data.push({
        quantity: x[i],
        id: v[i],
        properties: {
          _selling_1: y[i],
          _selling_2: z[i],
          _dynamicBoxId: "505328c4-d2f4-4a62-95fe-dee3b342d073",
          _dynamicBoxIndex: 0,
        },
      });
    }

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { items: data },
      dataType: "json",
      success: function () {
        updatecart();
      },
    });
  }
});

function clearcart() {
  //remove all items from cart

  $.ajax({
    async: false,
    type: "POST",
    url: "/cart/clear.js",
    success: function () {
      console.log("clear");
    },
    dataType: "json",
  });
}

//checkout button click function

$(".sidebar_checkout").on("click", function () {
  $(".close_menu").click();
  $("#PageContainer").css("opacity", 0);
  $("#precustomloader").css("display", "flex");
  setTimeout(function () {
    $("#dummy-checkout").click();
  }, 1000);
});

$(".sidebar_checkoutmeal").on("click", function () {
  $(".close_menu").click();
  $("#PageContainer").css("opacity", 0);
  $("#precustomloader").css("display", "flex");
  setTimeout(function () {
    $("#dummy-checkout").click();
  }, 1000);
});

$("#dummy-checkout").on("click", function () {
  $.ajax({
    async: false,
    type: "GET",
    url: "/cart.js",
    dataType: "json",
    contentType: "application/json",
    success: function (data) {
      checkallitems(data);
      if (data.items.length >= 7) {
        window.location.replace("/checkout");
      }
    },
  });
});

$(document).on(
  "click",
  "#continue-wrapper .btn , #continue-wrapper .no-thanks-upsell , .popUpmyclose, .checkout_area .fast-checkout, .cart__checkout-wrapper .fast-checkout",
  function () {
    $(".popUp-modal").hide();
    $("body").css("overflow", "unset");

    $("#PageContainer").css("opacity", 0);
    $("#precustomloader").css("display", "flex");

    $.ajax({
      async: false,
      type: "GET",
      url: "/cart.js",
      dataType: "json",
      contentType: "application/json",
      success: function (data) {
        checkallitems(data);
      },
    });
  }
);

// var popUpmodal = document.getElementById("popUpmyModal");
// var popUpspan = document.getElementsByClassName("popUpmyclose")[0];

// popUpspan.onclick = function () {
//   popUpmodal.style.display = "none";
//   document.body.style.overflow = "unset";
//   $.ajax({
//     async: false,
//     type: "GET",
//     url: "/cart.js",
//     dataType: "json",
//     contentType: "application/json",
//     success: function (data) {
//       checkallitems(data);
//       if (data.items.length >= 7) {
//         window.location.replace("/checkout");
//       }
//     },
//   });
// };

// window.onclick = function (event) {
//   if (event.target == popUpmodal) {
//     popUpmodal.style.display = "none";
//     document.body.style.overflow = "unset";
//   }
// };

function onload() {
  window.recharge.init({
    storeIdentifier: "buyfuelmeals.myshopify.com",
    storefrontAccessToken:
      "strfnt_6e85aceb3d795f4c6b3db0ef41cc28670198a8b32a9dd3563b8e8ce7e3a4d887",
    loginRetryFn: () => {
      return window.recharge.auth.loginShopifyAppProxy().then((session) => {});
    },
  });

  window.recharge.cdn.getCDNProducts().then((products) => {});
}

var el = document.createElement("script");
document.body.append(el);
el.onload = onload;
el.src =
  "https://static.rechargecdn.com/assets/storefront/recharge-client-1.7.0.min.js";
